<div class="multiple-sclerosis" #scrollContainer>
  <nz-layout>
    <nz-header>
      {{ "Precious MedSAM Segmentation" | translate }}
    </nz-header>

    <nz-content>
      <!-- 🔹 Top controls -->
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
        <div fxLayout="column" fxFlex="80">
          <nz-select
            nzShowSearch
            nzAllowClear
            [nzPlaceHolder]="'Select Imaging Record' | translate"
            [nzOptions]="imagingRecords"
            [(ngModel)]="selectedImaging"
            (ngModelChange)="onImagingSelected($event)"
            [disabled]="!hasPermission(['a-mss'])"
          ></nz-select>
        </div>

        <div fxLayout="column" fxFlex="20" *hasAddPermissions="['a-mss']">
          <button
            nz-button
            (click)="segment()"
            [disabled]="!selectedImaging || isLoading || !box"
          >
            {{ "Segment" | translate }}
          </button>
        </div>
      </div>

      <!-- 🔹 Results area -->
      @if (imageSrc) {
        <div
          class="segmentation-results"
          fxLayout="row"
          fxLayoutAlign="center stretch"
        >
          <!-- ================= LEFT: INTERACTIVE IMAGE ================= -->
          <div fxLayout="column" fxFlex="30">
            <div fxLayoutAlign="center center">
              {{ "Processed Image" | translate }}
            </div>

            <div class="segmentation-frame">
              <div class="bbox-stage">
                <img
                  #imgEl
                  class="bbox-image"
                  [src]="imageSrc"
                  (load)="onImageLoaded()"
                  draggable="false"
                />

                <div
                  #overlayEl
                  class="bbox-overlay"
                  (pointerdown)="onPointerDown($event)"
                  (pointermove)="onPointerMove($event)"
                  (pointerup)="onPointerUp($event)"
                  (pointercancel)="onPointerUp($event)"
                >
                  <div
                    class="bbox-rect"
                    *ngIf="drawRectVisible"
                    [style.left.px]="drawRect.left"
                    [style.top.px]="drawRect.top"
                    [style.width.px]="drawRect.width"
                    [style.height.px]="drawRect.height"
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div fxLayout="column" fxFlex="5"></div>

          <!-- ================= MIDDLE: MASK ================= -->
          <div fxLayout="column" fxFlex="30">
            <div fxLayoutAlign="center center">
              {{ "Prediction Mask" | translate }}
            </div>

            <div class="segmentation-frame">
              @if (isLoading && !result) {
                <div fxLayout="row" fxLayoutAlign="center center">
                  <nz-spin nzSimple></nz-spin>
                </div>
              }

              @if (result?.maskImage) {
                <img
                  nz-image
                  class="result-img"
                  [nzSrc]="'data:image/png;base64,' + result.maskImage"
                />
              }
            </div>
          </div>

          <div fxLayout="column" fxFlex="5"></div>

          <!-- ================= RIGHT: OVERLAY ================= -->
          <div fxLayout="column" fxFlex="30">
            <div fxLayoutAlign="center center">
              {{ "Overlay" | translate }}
            </div>

            <div class="segmentation-frame">
              @if (isLoading && !result) {
                <div fxLayout="row" fxLayoutAlign="center center">
                  <nz-spin nzSimple></nz-spin>
                </div>
              }

              @if (result?.overlayImage) {
                <img
                  nz-image
                  class="result-img"
                  [nzSrc]="'data:image/png;base64,' + result.overlayImage"
                />
              }
            </div>
          </div>
        </div>
      }
    </nz-content>
  </nz-layout>
</div>
